import React from 'react';
import feature_img from '../../../assets/img/Products/AeroGenix/2148578089.jpg';
import { AiOutlineAppstore, AiOutlineSolution } from 'react-icons/ai';
import { GoShieldLock } from "react-icons/go";
import { AiOutlineFileProtect } from "react-icons/ai";

export default function Feature6() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-8 items-center">
        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={feature_img}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Enterprise-Grade Security and Compliance
            </h1>
            <p className="text-lg text-gray-600">Your data is safe with us:</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <GoShieldLock className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Data Encryption</h3>
              </div>
              <p className="text-gray-600 text-sm">
                AES-256 encryption for data at rest, TLS/SSL for data in
                transit.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineAppstore className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Role-Based Access
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Role-based access control (RBAC) powered by Keycloak.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineFileProtect className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Automated Compliance
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Automated compliance with GDPR, HIPAA, and SOC2 standards.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
